import { render, staticRenderFns } from "./emolumentoClasse.vue?vue&type=template&id=0fa52e7e&scoped=true&"
import script from "./emolumentoClasse.vue?vue&type=script&lang=js&"
export * from "./emolumentoClasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa52e7e",
  null
  
)

export default component.exports